// extracted by mini-css-extract-plugin
export default {"wrapper":"GuestPhoto_wrapper__Kwf1g","withBorder":"GuestPhoto_withBorder__BAqaV"};